import React, { Component } from 'react'

class StatsBaseWindow extends Component {

    static propTypes = {
      id: React.PropTypes.string.isRequired,
      zIndex: React.PropTypes.number
    }

    static defaultProps = {
        zIndex: 5
    }
    
    constructor(props) {
        super(props);

        if(props.position != null) 
            this.position = props.position;
        else
            this.position = {top:10, left:10};
    }
    
    onDragStop(top, left) {
        this.props.StatisticActions.change_window_position(this.props.id, {top, left});
    }

    onResizeStop(width, height) {
        this.props.StatisticActions.change_window_size(this.props.id, width, height);
    }

    onToggleCutDown(isCutDown) {
        this.props.StatisticActions.toggle_cut_down_window(this.props.id, isCutDown);
    }
}


export default StatsBaseWindow


/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/StatsBaseWindow.js
 **/